import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { RecipientChipsInput } from './recipient-chips-input'

interface EmailRecipientFieldsProps {
  isReply: boolean
  toEmail: string
  toEmails: string[]
  ccEmails: string[]
  bccEmails: string[]
  ccVisible: boolean
  bccVisible: boolean
  disabled: boolean
  onToEmailsChange: (emails: string[]) => void
  onCcEmailsChange: (emails: string[]) => void
  onBccEmailsChange: (emails: string[]) => void
  onShowCc: () => void
  onShowBcc: () => void
}

export function EmailRecipientFields({
  isReply,
  toEmail,
  toEmails,
  ccEmails,
  bccEmails,
  ccVisible,
  bccVisible,
  disabled,
  onToEmailsChange,
  onCcEmailsChange,
  onBccEmailsChange,
  onShowCc,
  onShowBcc,
}: EmailRecipientFieldsProps) {
  return (
    <>
      <div className="grid gap-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="to">
            To {!isReply && <span className="text-destructive">*</span>}
          </Label>
          {!disabled && (
            <div className="flex items-center gap-2">
              {!ccVisible && (
                <button
                  type="button"
                  className="text-xs text-muted-foreground hover:text-foreground"
                  onClick={onShowCc}
                >
                  Cc
                </button>
              )}
              {!bccVisible && (
                <button
                  type="button"
                  className="text-xs text-muted-foreground hover:text-foreground"
                  onClick={onShowBcc}
                >
                  Bcc
                </button>
              )}
            </div>
          )}
        </div>
        {isReply ? (
          <Input
            id="to"
            value={toEmail}
            readOnly
            disabled
            className="bg-muted"
          />
        ) : (
          <RecipientChipsInput
            id="to"
            value={toEmails}
            onChange={onToEmailsChange}
            disabled={disabled}
            placeholder="Add a recipient and press Enter"
          />
        )}
      </div>

      {ccVisible && (
        <div className="grid gap-2">
          <Label htmlFor="cc">Cc</Label>
          <RecipientChipsInput
            id="cc"
            value={ccEmails}
            onChange={onCcEmailsChange}
            disabled={disabled}
            placeholder="Add a Cc recipient and press Enter"
          />
        </div>
      )}

      {bccVisible && (
        <div className="grid gap-2">
          <Label htmlFor="bcc">Bcc</Label>
          <RecipientChipsInput
            id="bcc"
            value={bccEmails}
            onChange={onBccEmailsChange}
            disabled={disabled}
            placeholder="Add a Bcc recipient and press Enter"
          />
        </div>
      )}
    </>
  )
}
